import { UserState, initialState } from "../state/UserState";
import { UserActions } from "../action/UserActions";
import { UserActionTypes } from "../action/index";

export function userReducer(state: UserState = initialState, action: UserActions): UserState {

    switch (action.type) {
        case UserActionTypes.USER_LOGIN:
            return {...state, expired: false, loading: true, error: false, user: null, token: null};
        case UserActionTypes.USER_LOGIN_SUCCESS:
            return {...state, authenticated: true, user: action.user, token: action.token, loading: false, error: false, expired: false};
        case UserActionTypes.USER_LOGIN_ERROR:
            return {...state, authenticated: false, loading: false, error: true, user: null, token: null};
        case UserActionTypes.USER_LOGOUT:
            return {...state, authenticated: false, loading: false, expired: false, token: null, error: false, resetPasswordError: false, user: null};
        case UserActionTypes.USER_SET_CUSTOMER_INFO:
            return {...state, contributor: action.contributor, organization: action.organization};
        case UserActionTypes.USER_RESET_PASSWORD_REQUEST:
            return {...state, loading: false, error: false, user: null, token: null, resetPasswordOk: false, resetPasswordError: false };
        case UserActionTypes.USER_RESET_PASSWORD:
            return {...state, loading: true, error: false, user: null, token: null, resetPasswordOk: false, resetPasswordError: false };
        case UserActionTypes.USER_RESET_PASSWORD_SUCCESS:
            return {...state, loading: false, resetPasswordOk: true, resetPasswordError: false };
        case UserActionTypes.USER_RESET_PASSWORD_ERROR:
            return {...state, loading: false, resetPasswordOk: false, resetPasswordError: true };
        case UserActionTypes.USER_EXPIRED:
            return {...state, authenticated: false, expired: true, token: null, error: false, resetPasswordError: false, user: null }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/UserReducer.ts